/// script tag helper module

interface Attr {
	defer?: boolean;
	async?: boolean;
}

export const scriptInlineTag = function (content: string, attr: Attr = {}) {
	const { async = true, defer = false } = attr;

	const asyncStr = async ? 'async' : '';
	const deferStr = defer ? 'defer' : '';

	/* 
    function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${PUBLIC_GTM}'
             */

	return `<script ${asyncStr} ${deferStr}>
        ${content}
    </script>`;
};
